import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { masterPassListCardNormalize } from 'Normalize';
import { onGetMasterpassTokenRequest } from 'Stores/CreditCardTransactions';
import { userStore } from 'Stores/User';
import { MasterPassTokenEnum } from 'Utils';

/**
 * Masterpass kayıtlı kart listesini İHTİYAÇ ANINDA yükler.
 *
 * ─── NEDEN ────────────────────────────────────────────────────────────────────
 * TL yükleme, abonman, otomatik talimat ve kart başvurusu ödeme adımında kredi
 * kartı listesi bir DIALOG içinde gösteriliyor; kullanıcı "kart seç"e basana
 * kadar listeden hiçbir şey ekrana çizilmiyor. Buna rağmen bu sayfalar listeyi
 * açılışta çekiyordu.
 *
 * Bu, zorunlu alanlar (kart, tutar) henüz seçilmemişken bir JWT + kart listesi
 * turu demek. Üstelik JWT servisi ödeme bağlamı olmadan token üretmediği için
 * bu erken çağrı zaten başarısız oluyor ("641 — Yükleme tipi belirtilmedi").
 *
 * Bu hook ile yükleme, listeye gerçekten bakılan ana — dialog açılışına — taşınır.
 *
 * ⚠️ Yan etki: liste artık sayfa açılışında hazır olmadığı için "son kullanılan
 * kart otomatik seçili gelsin" davranışı, kullanıcı seçim dialog'unu açana kadar
 * çalışmaz.
 */
export const useCreditCardList = () => {
  const dispatch = useDispatch();
  const { customerNumber, sessionToken } = useSelector(userStore);

  const loadCreditCardList = useCallback(() => {
    dispatch(
      onGetMasterpassTokenRequest({
        CustomerNumber: customerNumber,
        SessionToken: sessionToken,
        TokenType: MasterPassTokenEnum.CARD_LIST,
        request: {
          data: masterPassListCardNormalize(),
        },
      })
    );
  }, [dispatch, customerNumber, sessionToken]);

  return { loadCreditCardList };
};

export default useCreditCardList;
